/* eslint-disable*/

function updateUrlParameter(param, value) {
  const url = new URL(window.location.href);
  url.searchParams.set(param, value);
  window.location.href = url.toString();
}

function getURLParametersValue(queryString) {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(queryString);
}

function handleMobileFilters() {
  const searchField = document.querySelector(
    "[id^='edit-keys'] > [role='button']"
  );

  if (searchField) {
    searchField.parentNode.setAttribute("open", "");
    searchField.setAttribute("aria-expanded", true);
    searchField.setAttribute("aria-pressed", true);
  }

  const btnToggleFilter = document.querySelector(".mobile-filter-toggle");
  const groupFilters = document.querySelector(".form-group-filters");
  if (btnToggleFilter && groupFilters) {
    const filterItems = groupFilters.querySelectorAll(".js-form-wrapper");

    if (filterItems.length > 0) {
      filterItems.forEach((item) => {
        item.setAttribute("open", "");
        const btn = item.querySelector("[role='button']");

        if (btn) {
          btn.setAttribute("aria-expanded", true);
          btn.setAttribute("aria-pressed", true);
        }
      });
    }

    btnToggleFilter.addEventListener("click", () => {
      btnToggleFilter.classList.toggle("open");
      groupFilters.classList.toggle("open");
    });
  }
}

function handleSortDropdown() {
  const customDropdown = document.querySelector(".custom-dropdown");

  if (!customDropdown) return;

  const dropdownToggle = customDropdown.querySelector(".dropdown-toggle");
  const dropdownList = customDropdown.querySelector(".dropdown-list");

  const currentSortValue = getURLParametersValue("sort_bef_combine");

  const dropdownOptions = {
    created_ASC: "Date added (oldest)",
    created_DESC: "Date added (newest)",
    title_ASC: "Title (A-Z)",
    title_DESC: "Title (Z-A)",
  };

  if (currentSortValue) {
    dropdownToggle.textContent = dropdownOptions[currentSortValue];
  }

  dropdownToggle.addEventListener("click", function () {
    customDropdown.classList.toggle("open");
  });

  // Close the dropdown when clicking outside of it
  document.addEventListener("click", function (event) {
    if (!customDropdown.contains(event.target)) {
      customDropdown.classList.remove("open");
    }
  });

  // Handle item selection
  dropdownList.addEventListener("click", function (event) {
    if (event.target.tagName === "LI") {
      customDropdown.classList.remove("open");
      updateUrlParameter(
        "sort_bef_combine",
        event.target.getAttribute("data-value")
      );
    }
  });
}

function handleToggleFilterOptions() {
  const formElements = document.querySelectorAll(
    ".listing-page-flex-container .form-checkboxes.bef-checkboxes"
  );

  const LIMIT = 8;

  if (!formElements.length > 0) return;

  formElements.forEach((element) => {
    const checkboxes = element.querySelectorAll(".js-form-type-checkbox");

    const checkedItems = element.querySelectorAll('.js-form-type-checkbox input[checked="checked"]');

    if (checkedItems.length > 0) return;

    if (checkboxes.length > LIMIT) {
      for (let i = 0; i < checkboxes.length; i++) {
        if (i >= LIMIT) {
          checkboxes[i].style.display = "none";
        }
      }

      const btnShowAll = document.createElement("button");
      btnShowAll.type="button";
      btnShowAll.innerText = "Show all";
      btnShowAll.classList.add("button-show-all");
      btnShowAll.setAttribute("role", "button");

      btnShowAll.addEventListener("click", (e) => {
        for (let i = 0; i < checkboxes.length; i++) {
          checkboxes[i].style.display = "block";
        }

        btnShowAll.style.display = "none";
      });

      element.appendChild(btnShowAll);
    }
  });
}

function collapseFilterDropDownOnPageLoad() {
  const breakpoint = window.matchMedia('(min-width: 940px)');
  const  dropdownElements = document.querySelectorAll('.listing-page-flex-container details.js-form-wrapper:not(#edit-keys-2-collapsible)')
  if (breakpoint.matches && dropdownElements.length > 0) {

    setTimeout(() => {
      dropdownElements.forEach(el => {
        const summaryButton = el.querySelector('summary[role="button"]');
        const isChecked = el.querySelectorAll('input[type="checkbox"]:checked').length > 0 ? true : false;
        if (summaryButton && !isChecked) {
          summaryButton.click();
        }
      });
    }, 10);

  }
}

window.addEventListener("load", () => {
  collapseFilterDropDownOnPageLoad();
  handleMobileFilters();
  handleSortDropdown();
  handleToggleFilterOptions();
});
